<template>
    <div class="col-md-12" style="text-align: right !important;">
       
        <button type="button" class="btn" style="background-color: #F49315; color: white;"  @click="exportToExcel" >
            Reporte
        </button>
    </div>
    <h3 style="text-align: left;">Solicitudes de inspección</h3><br>
    <div class="col-md-12 row"> 
      <div class="col-md-4">
          <span>Inspector:</span>
          <select class="form-control">
              <option></option>
              <option :value="datos.email" v-for="datos  in datosinspectores">{{datos.email }}</option>
          </select>
      </div>
      <div class="col-md-4">
          <span>Buscar Columna:</span>
          <select class="form-control" v-model="searchField">
              <option value="folio_cotizacion">Cotización</option>
              <option value="solicitud_inspeccion">Solicitud de inspección</option>
              <option value="inspector">Inspector</option>

          </select>
  
          
      </div>
      <div class="col-md-4">
          <span>Buscar: </span>
          <input type="text" class="form-control" v-model="searchValue">
      </div>
    </div>
    <br>
    <EasyDataTable
    :headers="headers"
    :items="solicitudes"
    :search-field="searchField"
    :search-value="searchValue"
    :loading="loading"
    >
    <template #item-folio="item">
        <a href="#" @click="irCotizacion(item)">{{item.folio}}</a>
    </template>
    <template #item-razon_social="item">
        <a href="#" @click="irSolicitudInspeccion(item)">{{item.razon_social}}</a>
    </template>
    <template #item-formulario="item">
        <span v-if="item.formulario[0].estatus == 'Pendiente' " class="circle ">&nbsp;&nbsp;&nbsp;</span>
        <span v-if="item.formulario[0].estatus == 'Completado' " class="circlecolor">&nbsp;&nbsp;&nbsp;</span>
        <span v-if="item.formulario[1].estatus == 'Pendiente' " class="circle">&nbsp;&nbsp;&nbsp;</span>
        <span v-if="item.formulario[1].estatus == 'Completado' " class="circlecolor">&nbsp;&nbsp;&nbsp;</span>
        <span v-if="item.formulario[2].estatus == 'Pendiente' " class="circle">&nbsp;&nbsp;&nbsp;</span>
        <span v-if="item.formulario[2].estatus == 'Completado' " class="circlecolor">&nbsp;&nbsp;&nbsp;</span>
        <span v-if="item.formulario[3].estatus == 'Pendiente' " class="circle">&nbsp;&nbsp;&nbsp;</span>
        <span v-if="item.formulario[3].estatus == 'Completado' " class="circlecolor">&nbsp;&nbsp;&nbsp;</span>
        <span v-if="item.formulario[4].estatus == 'Pendiente' " class="circle">&nbsp;&nbsp;&nbsp;</span>
        <span v-if="item.formulario[4].estatus == 'Completado' " class="circlecolor">&nbsp;&nbsp;&nbsp;</span>
        <span v-if="item.formulario[5].estatus == 'Pendiente' " class="circle">&nbsp;&nbsp;&nbsp;</span>
        <span v-if="item.formulario[5].estatus == 'Completado' " class="circlecolor">&nbsp;&nbsp;&nbsp;</span>
        <span v-if="item.formulario[6].estatus == 'Pendiente' " class="circle">&nbsp;&nbsp;&nbsp;</span>
        <span v-if="item.formulario[6].estatus == 'Completado' " class="circlecolor">&nbsp;&nbsp;&nbsp;</span>
        <span v-if="item.formulario[7].estatus == 'Pendiente' " class="circle">&nbsp;&nbsp;&nbsp;</span>
        <span v-if="item.formulario[7].estatus == 'Completado' " class="circlecolor">&nbsp;&nbsp;&nbsp;</span>
    
    </template>
<template #item-operation="item">
    <div class="operation-wrapper">
      <!--<img
        src="./images/delete.png"
        class="operation-icon"
        @click="deleteItem(item)"
      />-->
      <!--<img
        src="./images/edit.png"
        class="operation-icon"
        @click="editItem(item)"
      />-->
      
      <button class="btn btn-light btn-sm"  type="button" @click="irSolicitudInspeccion(item)"><span class="fa fa-eye" style="color:#F49315;"></span></button> &nbsp;
      <!--<button class=" btn btn-light btn-sm" type="button" @click="generatePDF(item)"><span class="fa fa-file-pdf"></span></button> &nbsp;
 -->
      <button class="btn btn-light btn-sm" v-if="rol == 'Administrador' || 'Inspector' " type="button" @click="eliminarSolicitud(item)"><span class="fa  fa-trash" style="color:red;"></span></button>
   
    </div>
  </template>
  </EasyDataTable>
  <br>
</template>
<script>
import * as XLSX from 'xlsx';
import axios from 'axios';
import "vue3-easy-data-table/dist/style.css";
import Swal from 'sweetalert2';
import { mapState, mapMutations } from 'vuex';
export default {
    data() {
        return {
            loading:false,
            searchField:[],
            searchValue:[],
            datosinspectores:[],
            rol: localStorage.getItem('userRoles'),
            headers:[],
            solicitudes:[]
          
        }
    },
    created() {
        this.consultarInspector();
        this.consultarSolicitudes();
    },
    methods: {
        exportToExcel() {
            axios.post(this.$rutaServer+'reporteinspecciones')
            .then(response => {
              if (response.status == 200) {
                // Convertir datos a una hoja de trabajo
            const worksheet = XLSX.utils.json_to_sheet(response.data);
            
            // Crear un nuevo libro de trabajo y añadir la hoja de trabajo
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
            
            // Generar archivo Excel y descargarlo
            XLSX.writeFile(workbook, `${'inspecciones'}.xlsx`);
              }
            })
            .catch(error => {
              Swal.fire('¡Error!', 'Ocurrió un error', 'error');
            });
            
        },
        irCotizacion(item){
            
            localStorage.removeItem('idcotizacion');
            localStorage.setItem('idcotizacion',item.idcotizacion);
            this.$router.push('/mostrarcotizacion');
        },
        irSolicitudInspeccion(item){
            localStorage.removeItem('idcotizacion');
            localStorage.setItem('idcotizacion',item.idcotizacion);

            localStorage.removeItem('idnspeccion');
            localStorage.setItem('idinspeccion',item.id);
            this.$router.push('/informaciongeneralinspeccion');
        },
        consultarInspector(){
        const token = localStorage.getItem('accessToken');
            const config = {
                headers: {
                Authorization: `Bearer ${token}`,
                Accept: 'application/json'
                }
            };
       
        axios.get(this.$rutaServer +'inspectores',config)

          .then(response => {
            //console.log(response.data);
            this.datosinspectores = response.data.data;
            
          })
          .catch(error => {
            console.error('Error submitting form:', error);
           
          });
      },
      consultarSolicitudes(){
        this.loading = true;
        const token = localStorage.getItem('accessToken');
            const config = {
                headers: {
                Authorization: `Bearer ${token}`,
                Accept: 'application/json'
                }
            };
       
        //axios.get(this.$rutaServer +'api/inspectores',config)
        axios.post(this.$rutaServer +'consultarInspecciones')

          .then(response => {
            //console.log(response.data);
            this.loading = false;
            this.solicitudes = response.data;
            this.headers = [
                { text: "", value: "folio_inspeccion", sortable: true},
                { text: "Cotización", value: "folio_cotizacion", sortable: true},
                { text: "Solicitud de inspección", value: "solicitud_inspeccion", sortable: true },
                { text: "Inspector", value: "inspector", sortable: true },
                { text: "Operation", value: "operation", sortable: true },
                        
                       

                    ];
                    this.searchField  = ['folio_inspeccion','folio_cotizacion','solicitud_inspeccion','inspector'];
            
          })
          .catch(error => {
            console.error('Error submitting form:', error);
           
          });
      },
      async eliminarSolicitud(item){  
        const result = await Swal.fire({
                    title: '¿Estás seguro?',
                    text: '¡Confirma eliminar la solicitud de inspeccion!',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sí, eliminar',
                    cancelButtonText: 'Cancelar'
                });
               
      if (result.isConfirmed) {
        axios.post(this.$rutaServer +'eliminarInspeccion',{id:item.id})
          .then(response => {
            if(response.status == 200){
              Swal.fire('¡Éxito!', 'Cotizacion eliminada', 'success');
              this.consultarSolicitudes();
            }
           
            
          })
          .catch(error => {
            console.error('Error submitting form:', error);
           
          });
        }
      }
    },
}
</script>
<style>
.circle {
    width: 20px;
    height: 20px;
    background-color: red;
    border-radius: 50%;
    margin-right: 5px;
  }
  
  .circlecolor {
    width: 20px;
    height: 20px;
    background-color: green;
    border-radius: 50%;
    margin-right: 5px;
  }
</style>